export default {
  name: 'service-catalog',
  translationKey: 'service-catalog-module',
  routePrefix: 'service-catalog',
  routeNamePrefix: 'service-catalog',
  dependentTranslationKeys: ['advance-workflow-module'],
  mergeDependentTranslationKeys: true,
  directRoutesAvailable: true,
}
